// Define viewer event constants
//
// TODO: We should really considering moving away from constants and model events as classes instead (MOS-3305)
// Moreover, changing the values would break backwards compatibility with our existing data.
// These strings are defined in Piwik, are saved in Google Analytics accounts and Omniture, so changing them requires changes to those backends and db.
export const EVENT_CUSTOM_JAVASCRIPT_ACTIVATED = "Custom JavaScript action activated";
export const EVENT_EXPERIENCE_VIEWED = "Experience viewed";
export const EVENT_EXTERNAL_LINK_CLICK = "Click on link";
export const EVENT_JAVASCRIPT_ACTIVATED = "JavaScript action activated";
export const EVENT_NAVIGATION = "Navigation link clicked";
export const EVENT_OPEN_LIGHTBOX = "Open lightbox";
export const EVENT_QUICKVIEW_ACTIVATED = "Product Viewed";
export const EVENT_PRODUCT_WIDGET_CLICKED = "Product widget clicked";
export const EVENT_SOCIAL_SHARED_LINK_CLICK = "Click on social shared link";
export const EVENT_IMAGE_VIEWED = "Image_viewed";
export const EVENT_WIDGET_VIEWED = "Widget Viewed";
export const EVENT_BUTTON_WIDGET_VIEWED = "Button Widget Viewed";
export const EVENT_SFCC_WIDGET_VIEWED = "SFCC Widget Viewed";
export const EVENT_EMBED_WIDGET_VIEWED = "Embed Widget Viewed";
export const EVENT_IMAGE_WIDGET_VIEWED = "Image Widget Viewed";
export const EVENT_LINE_WIDGET_VIEWED = "Line Widget Viewed";
export const EVENT_LINK_WIDGET_VIEWED = "Link Widget Viewed";
export const EVENT_NEXT_SCENE_WIDGET_VIEWED = "Next Scene Widget Viewed";
export const EVENT_PREVIOUS_SCENE_WIDGET_VIEWED = "Previous Scene Widget Viewed";
export const EVENT_SCENE_NAVIGATOR_WIDGET_VIEWED = "Scene Navigator Widget Viewed";
export const EVENT_SHAPE_WIDGET_VIEWED = "Shape Widget Viewed";
export const EVENT_SOCIAL_SHARING_WIDGET_VIEWED = "Social Sharing Widget Viewed";
export const EVENT_TEXT_WIDGET_VIEWED = "Text Widget Viewed";
export const EVENT_YOUTUBE_WIDGET_VIEWED = "Youtube Widget Viewed";
export const EVENT_PRODUCT_WIDGET_VIEWED = "Product Widget Viewed";

export const LIGHTBOX_OPEN = "viewer:lightbox:open";
export const LIGHTBOX_CLOSE = "viewer:lightbox:close";
export const LINK_VISIT = "viewer:link:visit";
export const JAVASCRIPT_EXECUTE = "viewer:javascript:execute";
export const PRODUCT_VIEW = "viewer:product:view";
export const SCENE_NAVIGATE = "viewer:scene:navigate";
export const SOCIAL_NETWORK_SHARE = "viewer:social:share";
export const IMAGE_VIEW = "viewer:image:view";
export const WIDGET_VIEW = "viewer:widget:view";

// E.g. on Action failing to be activated
export const VIEWER_ERROR = "viewer:error";



// WEBPACK FOOTER //
// ./src/shared/services/tracker/ViewerEventsConstants.ts